<!-- Dialog: FILTER COPY-->
<p-dialog
  #dialog
  [(visible)]="data.dialogData.show"
  [width]="data.dialogData.width"
  [resizable]="false"
  [closable]="true"
  [modal]="false"
  [draggableDialog]="dialog"
  styleClass="bfx-dialog-normal"
  (onHide)="closeDialog()"
>
  <p-header class="dialog__header__filter-copy"> {{ data.dialogData.title_text }} </p-header>

  <div fxLayoutWrap fxLayout="column" class="dialog__body__filter-copy">
    <div fxLayout="row" fxFlexFill>
      <div fxFlex class="p-autocomplete-float-group">
        <bfx-text-input
          #copyFilter_filterName_autoComplete
          [(ngModel)]="data.dialogData.autocomplete_filterName"
          (ngModelChange)="helperCopyFilter_validateFilterName($event)"
          [maxLength]="50"
          size="sm"
          inputLabelText="Filter Name"
          [style]="{'width':'100%'}"
          [ngClass]="{'p-autocomplete p-autocomplete-float-input filter__dialog__filter-copy__autocomplete--filterName': true, 'p-autocomplete-float-input-valid': !!data.dialogData.autocomplete_filterName}"
        >
        </bfx-text-input>
        <div
          class="p-autocomplete-float-label-error"
          [ngStyle]="{ visibility: filterNameValid || filterNameEmpty ? 'hidden' : 'visible'}"
        >
          {{data.dialogData.message_text_name_invalid}}
        </div>
      </div>
    </div>

    <div fxLayout="row wrap" fxFlexFill>
      <div fxFlex="1 1 100%" class="p-autocomplete-float-group">
        <bfx-autoComplete
          #copyFilter_filterType_autoComplete
          [(ngModel)]="data.dialogData.autocomplete_filterType"
          [suggestions]="data.dialogData.autocomplete_filterTypesFiltered"
          field="label"
          size="sm"
          (completeMethod)="helperCopyFilter_searchAndValidateFilterType($event)"
          [dropdown]="true"
          (onSelect)="copyFilter_validateFilterType($event)"
          [useAlternateBlur]="true"
          nativeDesktopDropdown="generic"
          inputLabelText="Filter Type"
          autoHighlight="true"
          dataKey="value"
          delay="4"
          [minLength]="0"
          [style]="{'width':'100%'}"
          [ngClass]="{'p-autocomplete p-autocomplete-float-input filter__dialog__filter-copy__autocomplete--filterType': true,
                'p-autocomplete-float-input-valid': !!data.dialogData.autocomplete_filterType}"
        >
          <ng-template let-value pTemplate="item">
            <div class="ui-helper-clearfix">
              <div>{{value.label}}</div>
            </div>
          </ng-template>
        </bfx-autoComplete>

        <div
          class="p-autocomplete-float-label-error"
          [ngStyle]="{ visibility: filterTypeValid ? 'hidden' : 'visible'}"
        >
          {{ filterTypePartValid ? data.dialogData.message_text_part_invalid :
          data.dialogData.message_text_invalid}}
        </div>
      </div>
    </div>
  </div>

  <p-footer>
    <button
      pButton
      type="button"
      class="bfx-button-secondary-subtle"
      (click)="actionCopyFilter_close()"
      label="Cancel"
    ></button>
    <button
      pButton
      type="button"
      class="bfx-button-primary"
      (click)="actionCopyFilter_confirm()"
      label="Copy"
      [disabled]="!data.dialogData.autocomplete_filterName || !data.dialogData.autocomplete_filterType || filterTypeInvalid || !filterNameValid"
    ></button>
  </p-footer>
</p-dialog>
